<template>
  <div>
    <el-row>
      <el-col :span="22" class="text-white capitalize" style="
          font-size: 13px;
          text-align: right;
          padding: 5px;
          padding-right: 20px;
        ">
        <b>
          <span>
            <b>{{ username }}</b>
          </span>
          <span> / {{ faenaName(this.$store.getters.role.faena_id) }}</span>
          <span v-if="
            $store.getters.role.area_id &&
            this.$route.path !== '/es/seleccionar-roles'
          ">
            / {{ areaName($store.getters.role.area_id) }}</span>
          <span v-if="
            $store.getters.role.empresa_id &&
            this.$route.path !== '/es/seleccionar-roles'
          ">
            / {{ companyName($store.getters.role.empresa_id) }}</span>
          <span v-if="$store.getters.role.admin"> / Administrador</span>
          <span v-else> / {{ reviewerRoles[$store.getters.role.role] }}</span>
        </b>
      </el-col>
      <el-col :span="2">
        <el-button style="width: 100%; font-weight: bold;" type="danger" size="mini" @click="signOut()">{{ $t("SALIR")
        }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { reviewerRoles, coordinatorRoles } from "@/utils/generalObjects";

export default {
  name: "Roles",
  props: {
    roles: {
      type: Array,
      required: true,
    },
    currentRole: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reviewerRoles: {
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
        contractor_hse: "HSE Contratista",
        contract_owner: "Dueño de Contrato",
        administrator: "Administrador de Contrato",
        hse: "HSE",
        owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        manager: "Gerente",
        super: "Superintendente",
        general_manager: "Gerente General",
      },
      roleDescriptionView: false,
      faena: this.currentRole.faena_id,
      admin: this.currentRole.admin,
      aeId: null,
      role: null,
      aeOptions: [],
      rolesOptions: [],
      disabledAreasEmpresas: false,
      disabledRole: false,
      changeRoleDialog: false,
      reviewerRoles,
      coordinatorRoles,
      bhpProfiles: {
        hse: "HSE",
        health: this.$t("Especialista de Salud"),
        safety: this.$t("Especialista de Seguridad"),
        environment: this.$t("Especialista de Medioambiente"),
        contractor_hse: this.$t("HSE Contratista"),
        owner: this.$t("Dueño de Contrato"),
        contract_owner: this.$t("Dueño de Contrato"),
        risk: this.$t("Especialista de Riesgo"),
        administrator: this.$t("Administrador de Contrato"),
        contractor_coordinator: this.$t("Coordinador Contratista"),
        coordinator: this.$t("Coordinador"),
        manager: this.$t("Gerente"),
        super: this.$t("Superintendente"),
        general_manager: this.$t("Gerente General"),
      },
    };
  },
  mounted() {
    this.setAeOptions();
  },
  computed: {
    faenas() {
      return this.roles.map((r) => r.faena_id);
    },
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    empresas() {
      return this.$store.getters.empresas;
    },
  },
  methods: {
    setAeOptions() {
      if (this.roles) {
        const rolesFaena = this.roles.find((rf) => rf.faena_id === this.faena);
        this.aeOptions = [];
        if (rolesFaena) {
          if (rolesFaena.data.admin) {
            this.admin = true;
            this.aeId = null;
            this.role = this.$t("Administrador Plataforma");

            this.disabledAreasEmpresas = true;
            this.disabledRole = true;
          } else {
            // Obteneos Areas posibles
            if (rolesFaena.data.areas) {
              Object.keys(rolesFaena.data.areas).map((id) =>
                this.aeOptions.push({ _id: id, type: "Areas" })
              );
            }
            // Obtenemos Empresas posibles
            if (rolesFaena.data.empresas) {
              Object.keys(rolesFaena.data.empresas).map((id) =>
                this.aeOptions.push({ _id: id, type: "Empresas" })
              );
            }

            this.admin = false;
            this.role = null;
            this.disabledAreasEmpresas = false;
            this.disabledRole = false;
          }
        }
      }
    },
    setRolesOptions() {
      this.rolesOptions = [];
      const ae = this.aeOptions.find((i) => i._id === this.aeId);

      const rolesFaena = this.roles.find((rf) => rf.faena_id === this.faena);
      if (ae.type === "Areas") {
        const area = this.$store.getters.areasRoles.find(
          (i) => i._id === this.aeId
        );
        this.rolesOptions = rolesFaena.data.areas[ae._id].map((r) => ({
          role: r,
          name: this.bhpProfiles[r],
        }));

        if (area.area_padre_id === null && ae._id != "GeneralAreasRoles") {
          this.rolesOptions.unshift({
            role: "general_manager",
            name: this.bhpProfiles.general_manager,
          });
        } // if
      } else if (ae.type === "Empresas") {
        this.rolesOptions = rolesFaena.data.empresas[ae._id].map((r) => ({
          role: r,
          name: this.bhpProfiles[r],
        }));
      } // if
    },
    async changeRole() {
      // aunque si es admin entre faenas lo que hace es cambiar de faena y no el 'rol'
      // '' * se podria mantener el 'rol' y solo cambiar de 'faena' 'area'||'empresa'
      const ae = this.aeOptions.find((i) => i._id === this.aeId);
      const newRole = {
        faena_id: this.faena,
        admin: this.admin,
      };
      if (!this.admin) {
        // Area o Empresa
        if (ae.type === "Areas") {
          newRole.area_id = ae._id;
        } else {
          newRole.empresa_id = ae._id;
        }
        // Role
        newRole.role = this.role;
      } // if

      // reset datos de otros roles
      await this.$store.dispatch("resetEmpresasFaena");
      await this.$store.dispatch("resetAreas");
      await this.$store.dispatch("resetContract");
      await this.$store.dispatch("resetUserContractByRole");

      await this.$store.dispatch("setRole", newRole);
      this.redirect();
      this.changeRoleDialog = false;
    },
    redirect() {
      if (this.$route.name === "homePage") {
        this.$router.push({ name: "pushIndex" });
      } else {
        this.$router.push({ name: "homePage" });
      } // if
    },
    async signOut() {
      // reset datos de otros roles
      await this.$store.dispatch("resetEmpresasFaena");
      await this.$store.dispatch("resetAreas");
      await this.$store.dispatch("resetContract");
      await this.$store.dispatch("resetUserAllContracts");
      await this.$store.dispatch("resetUserContractByRole");
      await this.$store.dispatch("latestState", null);
      await this.$store.dispatch("setAllRiesgosPendientes", null);
      await this.$store.dispatch("updateData");

      await this.$store.dispatch("logout", this.$store.getters.user.id_sesion);
      if (window.location.hostname.includes("release.bhp.lifeon.cl")) {
        window.location = "https://release.bhp.lifeon.cl/logout";
      } else if (window.location.hostname.includes("dev.lifeon.cl")) {
        window.location = "https://bhp.dev.lifeon.cl/logout";
      } else if (window.location.hostname.includes("localhost")) {
        this.$router.push({ name: "homePage" });
      } else {
        window.location = "https://legacy.bhp.lifeon.cl/logout";
      }
    },
    faenaName(id) {
      if (this.$store.getters.faenasRoles) {
        const f =
          this.$store.getters.faenasRoles.find((f) => f._id === id) || {};
        return f.nombre.toLowerCase() || id;
      }
      return "";
    },
    areaName(id) {
      if (this.$store.getters.areasRoles) {
        const area = this.$store.getters.areasRoles.find((a) => a._id === id);
        return area ? area.nombre.toLowerCase() : id;
      }
      ("");
    },
    companyName(id) {
      if (this.empresas) {
        const empresa = this.empresas.find((x) => x._id === id);
        if (empresa && empresa.nombre) {
          return empresa.nombre.toLowerCase();
        }
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.userBtn {
  width: 100%;
}

.username {
  font-weight: 800;
  font-size: 18px;
}

.user-info {
  font-size: 14px;
}

.infoLogin {
  margin-top: 14px;
}

.capitalize {
  text-transform: capitalize;
}
</style>
